<script>
import PageHandler from '@utils/page-handler'
export default {
  name: 'PageNavigation',
  props: {
    total_page: {
      type: Number,
      default: 1,
    },
    cur_page: {
      type: Number,
      default: 1,
    },
    total_count: {
      type: Number,
      default: 0,
    },
    page_count: {
      type: Number,
      default: 10,
    },
    modal_check: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    page_navigation: function() {
      return new PageHandler(
        this.total_count,
        this.total_page || 1,
        this.cur_page,
        this.page_count
      )
    },
    page_nos: function() {
      const page_nos = []
      let page_no = null

      // eslint-disable-next-line no-cond-assign
      while ((page_no = this.page_navigation.getNextPage())) {
        page_nos.push(page_no)
      }

      return page_nos
    },
  },
}
</script>

<template>
  <div :class="[$style.pagination, $style.a1]">
    <router-link
      v-if="!modal_check"
      :to="{ query: Object.assign({}, $route.query, { page: undefined }) }"
      :class="$style.prevEnd"
      @click="$emit('change', 1)"
      >{{ $t('admin.first_page') }}</router-link
    >
    <a v-else :class="$style.prevEnd" @click="$emit('change', 1)">{{
      $t('admin.first_page')
    }}</a>
    <template v-for="page_no in page_nos">
      <template v-if="!modal_check">
        <strong v-if="page_no === cur_page" :key="page_no">{{
          page_no
        }}</strong>
        <router-link
          v-else
          :key="page_no"
          :to="{ query: Object.assign({}, $route.query, { page: page_no }) }"
          @click="$emit('change', page_no)"
          >{{ page_no }}</router-link
        >
      </template>
      <template v-else>
        <strong v-if="page_no === cur_page" :key="page_no">{{
          page_no
        }}</strong>
        <a v-else :key="page_no" @click="$emit('change', page_no)">{{
          page_no
        }}</a>
      </template>
    </template>
    <router-link
      v-if="!modal_check"
      :to="{
        query: Object.assign({}, $route.query, {
          page: page_navigation.last_page,
        }),
      }"
      :class="$style.nextEnd"
      @click="$emit('change', page_navigation.last_page)"
      >{{ $t('admin.last_page') }}</router-link
    >
    <a
      v-else
      :class="$style.nextEnd"
      @click="$emit('change', page_navigation.last_page)"
      >{{ $t('admin.last_page') }}</a
    >
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/font.scss';
@import '@src/design/pagination.scss';
</style>
